import React, { BaseSyntheticEvent, useCallback } from 'react';
import style from './IconButton.module.scss';
import { clsx } from 'clsx';

const IconButton = ({
  active = false,
  className = '',
  children,
  disabled = false,
  hasBorder = false,
  onClick,
  size = null,
  title = '',
  dataSentryElement,
}: {
  active?: boolean;
  alt?: string;
  children: React.ReactNode;
  className?: string;
  disabled?: boolean;
  hasBorder?: boolean;
  onClick?: (e: BaseSyntheticEvent) => void;
  size?: number | null;
  title?: string;
  /** Stable name of the action, read by the Sentry SDK instead of the styled class. */
  dataSentryElement?: string;
}) => {
  const handleClick = useCallback(
    (e: BaseSyntheticEvent) => {
      if (onClick) onClick(e);
    },
    [onClick]
  );

  return (
    <button
      className={clsx(
        style.iconButton,
        hasBorder && style.hasBorder,
        disabled && style.disabled,
        active && style.active,
        className && className
      )}
      onClick={disabled ? undefined : handleClick}
      data-sentry-element={dataSentryElement}
      disabled={disabled}
      title={title ? title : undefined}
      style={
        size
          ? {
              width: `${size}px`,
              height: `${size}px`,
              minWidth: `${size}px`,
              minHeight: `${size}px`,
            }
          : undefined
      }
    >
      {children}
    </button>
  );
};

export default IconButton;
